import { useEffect, useState } from 'react';

// A deadline stays accurate when mobile browsers throttle background timers.
export default function useCountdown(deadline) {
  const remaining = () => Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
  const [seconds, setSeconds] = useState(remaining);
  useEffect(() => {
    setSeconds(remaining());
    if (!deadline) return;
    const timer = setInterval(() => setSeconds(remaining()), 250);
    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deadline]);
  return seconds;
}
